import { Theme } from '@material-ui/core';
import {Colors} from "@/themes/colors";

export const MuiRadio = (theme: Theme): Record<string, unknown> => ({
  root: {
    color: Colors.DarkPurple
  },
});
